import { Clock3, Eye, Sparkles } from 'lucide-react';
import type { Status } from '../types';

const labels: Record<Status, string> = { new: 'Nowa', watching: 'Obserwowane', analysis: 'Do analizy', rejected: 'Odrzucona', purchased: 'Kupiona' };
export function StatusPill({ status }: { status: Status }) {
  const Icon = status === 'watching' ? Eye : status === 'analysis' ? Clock3 : Sparkles;
  return <span className={`status status-${status}`}><Icon size={14} />{labels[status]}</span>;
}
